import { PaymentMethodType } from '../../models/paymentMethods/enums';
import {
    ORDER_STATUS_POLLING_LONG_PERIOD_IN_MS,
    ORDER_STATUS_POLLING_PERIOD_IN_MS,
    STRIPE_SLOW_ORDER_STATUS_POLLING_DURATION_IN_MS,
    STRIPE_STATUS_POLLING_LONG_PERIOD_IN_MS,
} from './constants';

export const getPollingPeriod = ({
    paymentMethod,
    attempts,
    pollingEllapsedTimeInMs,
}: {
    attempts: number;
    paymentMethod?: PaymentMethodType;
    pollingEllapsedTimeInMs: number;
}) => {
    if (attempts === 1) {
        return ORDER_STATUS_POLLING_LONG_PERIOD_IN_MS;
    }

    if (
        paymentMethod === PaymentMethodType.STRIPE_CONFIRMATION_TOKEN &&
        pollingEllapsedTimeInMs >=
            STRIPE_SLOW_ORDER_STATUS_POLLING_DURATION_IN_MS
    ) {
        return STRIPE_STATUS_POLLING_LONG_PERIOD_IN_MS;
    }

    return ORDER_STATUS_POLLING_PERIOD_IN_MS;
};
